import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Fornecedor } from '../../types/aquisicao';
import { fornecedoresService } from '../../services';

const columns: ResourceColumn<Fornecedor>[] = [
  { header: 'Razão social', accessor: 'razao_social' },
  {
    header: 'Tipos de madeira',
    render: (item) =>
      item.tipos_madeira_info?.map((tipo) => tipo.descricao).join(', ') || '—',
  },
  {
    header: 'Certificações',
    render: (item) =>
      item.certificacoes_info?.map((cert) => cert.descricao).join(', ') || '—',
  },
  {
    header: 'Cidade/UF',
    render: (item) => [item.cidade, item.uf].filter(Boolean).join(' / '),
  },
  { header: 'E-mail', accessor: 'email' },
];

export const FornecedoresListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Fornecedores"
      description="Cadastro de fornecedores homologados de madeira."
      columns={columns}
      service={fornecedoresService}
      createPath="/admin/aquisicao/fornecedores/novo"
      onEdit={(item) =>
        item.id &&
        navigate('/admin/aquisicao/fornecedores/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? fornecedoresService.remove(item.id) : Promise.resolve())}
    />
  );
};
